import * as actionTypes from './../actions/signalmentAction';

const initialState = {
  selectedSterilised: null,
  selectedPregnant: null,
  selectedLactation: null,
  data: [],
  pending: true,
  error: null,
  ready: false,
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.SELECT_STERILISED:
      return {
        ...state,
        selectedSterilised: action.selectedSterilised
      };
    case actionTypes.SELECT_PREGNANT:
      return {
        ...state,
        selectedPregnant: action.selectedPregnant
      };
    case actionTypes.SELECT_LACTATION:
      return {
        ...state,
        selectedLactation: action.selectedLactation
      };
    case actionTypes.DEFAULT:
      return {
        ...state,
        selectedSterilised: false,
        selectedPregnant: false,
        selectedLactation: false,
        ready: true,
      };
    case actionTypes.FETCH_DATA_PENDING:
      return {
        ...state,
        pending: true
      };
    case actionTypes.FETCH_DATA_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data
      };
    case actionTypes.FETCH_DATA_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default reducer;
